var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`chart learners-engagement md-layout-item md-size-${_vm.width} md-medium-size-${_vm.width} md-small-size-100`},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.label))]),_c('div',[_c('apexchart',{attrs:{"type":"bar","height":"320","options":_vm.chartOptions,"series":_vm.series}})],1),_c('div',{staticClass:"spacer"},[_vm._v(" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }